

// import { createTheme, ThemeProvider, Typography } from '@mui/material';
// import './App.css';
// import MyAppBar from './Components/AppBar/CustomAppBar';

// import { Link, Route, Routes, useLocation } from "react-router-dom";
// import Home from './Pages/Home/Home';
// import LoginComponent from './Pages/Login/LoginComponent';
// import RegisterPage from './Pages/Login/RegisterPage';
// import Events from './Pages/Post/Events/Events';
// import MentorRequirement from './Pages/Post/MentorRequirement/MentorRequirement';
// import Newsletter from './Pages/Post/Newsletter/Newsletter';
// import AddButtonPage from './Components/AddButtonPage/AddButtonPage';
// import EventHome from './Pages/Post/Events/EventHome';
// import MentorRequirementHome from './Pages/Post/MentorRequirement/MentorRequirementHome';
// import NewsletterHome from './Pages/Post/Newsletter/NewsletterHome';
// import RegistrationAlumniCofirmed from './Pages/Reports/Registration/RegistrationAlumniCofirmed';
// import AlumniReportSearchByCourse from './Pages/Reports/SearchByCourse/AlumniReportSearchByCourse';
// import AlumniReportSearchByName from './Pages/Reports/SearchByName/AlumniReportSearchByName';
// import ProfileDetails from './Pages/Reports/ProfileDetails/ProfileDetails';
// import ChangePassword from './Components/AppBar/ChangePassword';
// import AboutUs from './Pages/AboutUs/AboutUs';
// import { UserRoute } from './Pages/UserRoute';
// import { AdminRoute } from './Pages/AdminRoute';
// import { AuthProvider } from './Pages/AuthContext';
// import UserLayout from './Pages/Layout/UserLayout';
// import AdminLayout from './Pages/Layout/AdminLayout';
// // import Home from './Pages/Home';
// // import HomeAllSection from './Pages/Home/HomeAllSection';
// // import Footer from './Components/Footer/Footer';

// const theme = createTheme({
//   typography: {
//     fontFamily: "Roboto, Arial, sans-serif", // Default font for body
//     h1: {
//       fontFamily: "Poppins",
//       fontWeight: "200",
//       fontSize: "50px",
//       [`@media (max-width:600px)`]: {
//         fontSize: "40px", // Larger font size for larger screens
//       },
//     },
//     h2: {
//       fontFamily: "Poppins",
//       fontWeight: "medium",
//       fontSize: "40px",
//       [`@media (max-width:600px)`]: {
//         fontSize: "30px", // Larger font size for larger screens
//       },
//     },
//     h3: {
//       fontFamily: "Poppins",
//       fontWeight: "bold",
//       fontSize: "33px",
//       [`@media (max-width:600px)`]: {
//         fontSize: "22px", // Larger font size for larger screens
//       },
//     },
//     h6: {
//       fontFamily: "Poppins",
//       fontWeight: "medium",
//       fontSize: "18px",
//       color: "#252525",
//       [`@media (max-width:600px)`]: {
//         fontSize: "16px", // Larger font size for larger screens
//       },
//     },
//     h5: {
//       fontFamily: "Poppins",
//       fontWeight: "medium",
//       fontSize: "16px",
//       color: "#9c9ca2",
//       [`@media (max-width:600px)`]: {
//         fontSize: "14px", // Larger font size for larger screens
//       },
//     },

//     body1: {
//       fontFamily: "sans-serif",
//       fontWeight: "normal",
//       fontSize: "14px",
//       color: "#b4b4b7",
//       [`@media (max-width:600px)`]: {
//         fontSize: "11px", // Larger font size for larger screens
//       },
//     },
//     body2: {
//       fontFamily: "Roboto",
//       fontWeight: "bold",
//       fontSize: "16px",
//       [`@media (max-width:600px)`]: {
//         fontSize: "14px", // Larger font size for larger screens
//       },
//     },
//     subtitle1: {
//       fontFamily: "Roboto",
//       fontWeight: "normal",
//       fontSize: "15px",
//       [`@media (max-width:600px)`]: {
//         fontSize: "13px", // Larger font size for larger screens
//       },
//     },
//     subtitle2: {
//       fontFamily: "poppins",
//       fontWeight: "normal",
//       fontSize: "14px",
//       [`@media (max-width:600px)`]: {
//         fontSize: "12px", // Larger font size for larger screens
//       },
//     },
//     footerText: {
//       fontFamily: "poppins",
//       fontWeight: "normal",
//       fontSize: "14px",
//       [`@media (max-width:600px)`]: {
//         fontSize: "12px", // Larger font size for larger screens
//       },
//     },
//     button: {
//       fontFamily: "sans-serif", // Buttons will use Poppins
//       fontWeight: "normal",
//       textTransform: "uppercase", // Optional: makes text uppercase
//       fontSize: "16px",

//       [`@media (max-width:600px)`]: {
//         fontSize: "12px", // Larger font size for larger screens
//       },
//     },
//   },
//   components: {
//     // MuiButton: {
//     //   styleOverrides: {
//     //     root: {
//     //       fontFamily: "Poppins", // Ensure Poppins applies to buttons
//     //       fontWeight: "bold",
//     //       fontSize: "0.875rem",
//     //       textTransform: "uppercase", // Optional: uppercase for buttons
//     //     },
//     //   },
//     // },
//     MuiListItemText: {
//       styleOverrides: {
//         primary: {
//           fontFamily: "Poppins", // Custom font
//           fontWeight: "medium",
//           fontSize: "16px",
//         },
//       },
//     },
//     MuiListItem: {
//       styleOverrides: {
//         primary: {
//           fontFamily: "Poppins", // Custom font
//           fontWeight: "medium",
//           fontSize: "16px",
//         },
//       },
//     },
//     MuiMenuItem: {
//       styleOverrides: {
//         root: {
//           fontFamily: "Roboto", // Menu items use Roboto
//           fontSize: "1rem",
//           fontWeight: "normal",
//         },
//       },
//     },
//   },
// });

// const Layout = ({ children }) => {
//   const location = useLocation();
//   const hideHeaderAndFooter =
//     location.pathname === "/" ||
//     location.pathname === "/register" ||
//     location.pathname === "/changepassword" ||
//     // location.pathname === "/re-approval";
//     location.pathname.startsWith("/re-approval") ||
//     location.pathname === "/rejectstatus" ||
//     location.pathname === "/withdraw";





//   return (
//     <>
//       {!hideHeaderAndFooter && <MyAppBar />}
//       <div style={{ backgroundColor: "#edf2f6" }}>{children}</div>
//       {/* {!hideHeaderAndFooter && <Footer />} */}
//     </>
//   );
// };



// function App() {
//   return (
//     // <ThemeProvider theme={theme}>
//     //   <Layout >


//     //     <Routes>
//     //     <Route path="/" element={<LoginComponent />} />
//     //     <Route path="/register" element={<RegisterPage />} />


//     //       {/* this is admin router */}
//     //       <Route path="/changepassword" element={<ChangePassword />} />
//     //       <Route path="/home" element={<Home />} />
//     //       <Route path="/events" element={<EventHome />} />
//     //       {/* <Route path="/eventadd" element={<Events />} /> */}
//     //       <Route path="/mentor_requirement" element={<MentorRequirementHome />} />
//     //       <Route path="/newsletter" element={<NewsletterHome />} />
//     //       <Route path="/alumni_register_confirmation" element={<RegistrationAlumniCofirmed />} />
//     //       <Route path="/reportsearch_course" element={<AlumniReportSearchByCourse />} />
//     //       <Route path="/reportsearch_name" element={<AlumniReportSearchByName />} />
//     //       <Route path="/profiledetails" element={<ProfileDetails />} />
//     //       <Route path="/aboutus" element={<AboutUs />} />

//     //       {/* this is user router */}
//     //       <Route path="/user" element={<AboutUs />} />


//     //     </Routes>
//     //   </Layout>

//     // </ThemeProvider>
//     <ThemeProvider theme={theme}>
//       <AuthProvider>
//         <Layout>
//           <Routes>
//             {/* Public Routes */}
//             {/* <Route element={<Layout />}> */}
//             <Route path="/" element={<LoginComponent />} />
//             <Route path="/register" element={<RegisterPage />} />
//             {/* </Route> */}

//             {/* Admin Routes */}
//             <Route path="/admin" element={<AdminLayout />}>
//               <Route path="home" element={<AdminRoute element={<Home />} />} />
//               <Route path="changepassword" element={<AdminRoute element={<ChangePassword />} />} />
//               <Route path="events" element={<AdminRoute element={<EventHome />} />} />
//               <Route path="mentor_requirement" element={<AdminRoute element={<MentorRequirementHome />} />} />
//               <Route path="newsletter" element={<AdminRoute element={<NewsletterHome />} />} />
//               <Route path="alumni_register_confirmation" element={<AdminRoute element={<RegistrationAlumniCofirmed />} />} />
//               <Route path="reportsearch_course" element={<AdminRoute element={<AlumniReportSearchByCourse />} />} />
//               <Route path="reportsearch_name" element={<AdminRoute element={<AlumniReportSearchByName />} />} />
//               <Route path="profiledetails" element={<AdminRoute element={<ProfileDetails />} />} />
//             </Route>

//             {/* User Routes */}
//             <Route path="/user" element={<UserRoute element={<UserLayout />} />}>
//               <Route index element={<AboutUs />} />
//               <Route path="aboutus" element={<AboutUs />} />
//               {/* Add more user routes here */}
//             </Route>
//           </Routes>
//         </Layout>
//       </AuthProvider>
//     </ThemeProvider>
//   );
// }

// export default App;






import { createTheme, ThemeProvider, Typography } from '@mui/material';
import './App.css';
import MyAppBar from './Components/AppBar/CustomAppBar';

import { Link, Outlet, Route, Routes, useLocation } from "react-router-dom";

import { UserRoute } from './Pages/UserRoute';
import { AdminRoute } from './Pages/AdminRoute';
import { AuthProvider } from './Pages/AuthContext';
import LoginComponent from './Pages/Login/LoginComponent';
import RegisterPage from './Pages/Login/RegisterPage';
import AdminLayout from './Pages/Layout/AdminLayout';
import Home from './Pages/Admin/Home/Home';
import MentorRequirementHome from './Pages/Admin/Post/MentorRequirement/MentorRequirementHome';
import EventHome from './Pages/Admin/Post/Events/EventHome';
import NewsletterHome from './Pages/Admin/Post/Newsletter/NewsletterHome';
import RegistrationAlumniCofirmed from './Pages/Admin/Reports/Registration/RegistrationAlumniCofirmed';
import AlumniReportSearchByCourse from './Pages/Admin/Reports/SearchByCourse/AlumniReportSearchByCourse';
import AlumniReportSearchByName from './Pages/Admin/Reports/SearchByName/AlumniReportSearchByName';
import ProfileDetails from './Pages/Admin/Reports/ProfileDetails/ProfileDetails';
import AboutUs from './Pages/Admin/AboutUs/AboutUs';
import WebsiteSideNav from './Components/WebsiteSideNav/WebsiteSideNav';
import HomePage from './Pages/Website/HomeProfile/HomePage';
// import ChangePassword from './Components/AppBar/ChangePassword'/s;
import Connections from './Pages/Website/Connections/ConnectionsHome';
import ConnectionsHome from './Pages/Website/Connections/ConnectionsHome';
import UserLayout from './Pages/Layout/UserLayout';
import PostJobHome from './Pages/Website/PostJobs/PostJob/PostJobHome';
import PostInernshipHome from './Pages/Website/PostJobs/PostInternship/PostInernshipHome';
import SearchJobVacancy from './Pages/Website/PostJobs/SearchJobs/SearchJobVacancy';
import SearchInternshipVacancy from './Pages/Website/PostJobs/SearchInternship/SearchInternshipVacancy';
import ResumeUpload from './Pages/Website/PostJobs/ResumeUpload/ResumeUpload';
import MessageChatHome from './Pages/Website/MessageChat/MessageChatHome';
// import Notification from './Pages/Website/Notification/Notification';
import EditProfilePage from './Pages/Website/EditProfile/EditProfilePage';
import { ToastContainer } from 'react-toastify';
import AllUsers from './Pages/Website/AllUsers/AllUsers';
import SuggestionConnections from './Pages/Website/Connections/SuggestionConnections';
import MyConnections from './Pages/Website/Connections/MyConnections';
import AdminLoginComponent from './Pages/Login/AdminLoginComponent';
import Notification from './Pages/Website/Notification/Notification';
import ChangePassword from './Pages/Website/ChangePassword';
import ChangePasswordForAdmin from './Pages/Website/ChangePasswordForAdmin';
import BrandingSettings from './Components/CustomSettings/CustomSetttings';
import { useEffect } from 'react';
import actions from './ReduxStore/actions';
import { useDispatch, useSelector } from 'react-redux';
import { adminUrl } from './constants';
import staticLogo from "./Assets/WeConnectLogo.png"
import staticLBanner from "./Assets/adminBannerImage.webp"


// import PostInternshipHome from './Pages/Website/Po
// stJobs/PostInternship/PostInternShipHome';
// import UserLayout from './Pages/Layout/UserLayout';
// import AdminLayout from './Pages/Layout/AdminLayout';
// import HomeProfile from './Pages/HomeProfile/HomeProfile';
// import WebsiteSideNav from './Components/WebsiteSideNav/WebsiteSideNav';
// import HomePage from './Pages/HomeProfile/HomePage';
// import Home from './Pages/Home';
// import HomeAllSection from './Pages/Home/HomeAllSection';
// import Footer from './Components/Footer/Footer';

const theme = createTheme({
  typography: {
    fontFamily: "Roboto, Arial, sans-serif", // Default font for body
    h1: {
      fontFamily: "Poppins",
      fontWeight: "200",
      fontSize: "50px",
      [`@media (max-width:600px)`]: {
        fontSize: "40px", // Larger font size for larger screens
      },
    },
    h2: {
      fontFamily: "Poppins",
      fontWeight: "medium",
      fontSize: "40px",
      [`@media (max-width:600px)`]: {
        fontSize: "30px", // Larger font size for larger screens
      },
    },
    h3: {
      fontFamily: "Poppins",
      fontWeight: "bold",
      fontSize: "33px",
      [`@media (max-width:600px)`]: {
        fontSize: "22px", // Larger font size for larger screens
      },
    },
    h6: {
      fontFamily: "Poppins",
      fontWeight: "medium",
      fontSize: "18px",
      color: "#252525",
      [`@media (max-width:600px)`]: {
        fontSize: "16px", // Larger font size for larger screens
      },
    },
    h5: {
      fontFamily: "Poppins",
      fontWeight: "medium",
      fontSize: "16px",
      color: "#9c9ca2",
      [`@media (max-width:600px)`]: {
        fontSize: "14px", // Larger font size for larger screens
      },
    },

    body1: {
      fontFamily: "sans-serif",
      fontWeight: "normal",
      fontSize: "14px",
      color: "#b4b4b7",
      [`@media (max-width:600px)`]: {
        fontSize: "11px", // Larger font size for larger screens
      },
    },
    body2: {
      fontFamily: "Roboto",
      fontWeight: "bold",
      fontSize: "16px",
      [`@media (max-width:600px)`]: {
        fontSize: "14px", // Larger font size for larger screens
      },
    },
    subtitle1: {
      fontFamily: "Roboto",
      fontWeight: "normal",
      fontSize: "15px",
      [`@media (max-width:600px)`]: {
        fontSize: "13px", // Larger font size for larger screens
      },
    },
    subtitle2: {
      fontFamily: "poppins",
      fontWeight: "normal",
      fontSize: "14px",
      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },
    customText: {
      fontFamily: "Poppins", // Custom font
      fontWeight: "medium",
      fontSize: "16px",
      color: "#6f6c6c",
      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },
    footerText: {
      fontFamily: "poppins",
      fontWeight: "normal",
      fontSize: "14px",
      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },
    button: {
      fontFamily: "sans-serif", // Buttons will use Poppins
      fontWeight: "normal",
      textTransform: "uppercase", // Optional: makes text uppercase
      fontSize: "16px",

      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },
  },
  components: {
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       fontFamily: "Poppins", // Ensure Poppins applies to buttons
    //       fontWeight: "bold",
    //       fontSize: "0.875rem",
    //       textTransform: "uppercase", // Optional: uppercase for buttons
    //     },
    //   },
    // },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontFamily: "Poppins", // Custom font
          fontWeight: "medium",
          fontSize: "17px",
          color: "#6f6c6c"
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        primary: {
          fontFamily: "Poppins", // Custom font
          fontWeight: "medium",
          fontSize: "16px",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "Roboto", // Menu items use Roboto
          fontSize: "1rem",
          fontWeight: "normal",
        },
      },
    },
  },
});

// const Layout = ({ children }) => {
//   const location = useLocation();
//   const hideHeaderAndFooter =
//     location.pathname === "/" ||
//     location.pathname === "/register" ||
//     location.pathname === "/changepassword" ||
//     // location.pathname === "/re-approval";
//     location.pathname.startsWith("/re-approval") ||
//     location.pathname === "/rejectstatus" ||
//     location.pathname === "/withdraw";





//   return (
//     <>
//       {!hideHeaderAndFooter && <MyAppBar />}
//       <div style={{ backgroundColor: "#edf2f6" }}>{children}</div>
//       {/* {!hideHeaderAndFooter && <Footer />} */}
//     </>
//   );
// };

const Layout = () => {
  const location = useLocation();

  const hideHeaderAndFooter =
    location.pathname === "/" ||
    location.pathname === "/register" ||
    location.pathname === "/changepassword" ||
    location.pathname.startsWith("/re-approval") ||
    location.pathname === "/rejectstatus" ||
    location.pathname === "/withdraw";

  return (
    <>
      {!hideHeaderAndFooter && <MyAppBar />}
      <div style={{ backgroundColor: "#edf2f6" }}>
        <Outlet />
      </div>
    </>
  );
};




function App() {
  const { saveSiteSettings } = useSelector(
    (state) => state?.saveSiteSettings
  );

  const { getSiteSettings } = useSelector(
    (state) => state?.getSiteSettings
  );

  const dispatch = useDispatch()
  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getSiteSettings`
      };
      const response = await dispatch(actions.GETSITESETTINGS(data1));
      console.log(response?.payload?.data?.favicon, "responsedataaaaaaa")
      if (response?.payload?.message === "Site settings fetched successfully.") {
        let link = document.querySelector("link[rel~='icon']");

        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }

        link.href = `${adminUrl}${response?.payload?.data?.favicon}` || '';
        // Dynamically set CSS variables
        const root = document.documentElement;
        if (response?.payload?.data?.primary_color) {
          root.style.setProperty('--main-color', response?.payload?.data?.primary_color || '#28a8e0');
          // root.style.setProperty('--table-headbackgroungcolor', siteData.theme.tableHeadBackgroundColor || 'gray');
          // root.style.setProperty('--main-contentbackgroundcolor', siteData.theme.mainContentBackgroundColor || '#edf2f6');
        }
      }

    }
    fetchData()

  }, [saveSiteSettings])

  const dynamicLogo = `${adminUrl}${getSiteSettings?.data?.logo}` || staticLogo;
  console.log(dynamicLogo, "dynamicLogo")
  const dynamiBanner = `${adminUrl}${getSiteSettings?.data?.banner_image}` || staticLBanner;
  const dynamicCampusName = `${getSiteSettings?.data?.company_name}` || "Cygnusa";




  return (
    // <ThemeProvider theme={theme}>
    //   <AuthProvider>
    //     <Routes>
    //       {/* Routes that use Layout */}
    //       <Route element={<Layout />}>
    //         {/* Public Routes */}
    //         <Route path="/" element={<LoginComponent />} />
    //         <Route path="/register" element={<RegisterPage />} />

    //         {/* Admin Routes */}
    //         <Route path="/admin" element={<AdminLayout />}>
    //           <Route path="home" element={<AdminRoute element={<Home />} />} />
    //           <Route path="changepassword" element={<AdminRoute element={<ChangePassword />} />} />
    //           <Route path="events" element={<AdminRoute element={<EventHome />} />} />
    //           <Route path="mentor_requirement" element={<AdminRoute element={<MentorRequirementHome />} />} />
    //           <Route path="newsletter" element={<AdminRoute element={<NewsletterHome />} />} />
    //           <Route path="alumni_register_confirmation" element={<AdminRoute element={<RegistrationAlumniCofirmed />} />} />
    //           <Route path="reportsearch_course" element={<AdminRoute element={<AlumniReportSearchByCourse />} />} />
    //           <Route path="reportsearch_name" element={<AdminRoute element={<AlumniReportSearchByName />} />} />
    //           <Route path="profiledetails" element={<AdminRoute element={<ProfileDetails />} />} />
    //         </Route>

    //         {/* User Routes */}
    //         <Route path="/user" element={<UserRoute element={<UserLayout />} />}>
    //           <Route index element={<AboutUs />} />
    //           <Route path="aboutus" element={<AboutUs />} />
    //           {/* More user routes */}
    //         </Route>
    //       </Route>
    //     </Routes>
    //   </AuthProvider>
    // </ThemeProvider>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Routes>
          {/* Public Routes without Layout */}
          <Route path="/" element={<LoginComponent dynamicLogo={dynamicLogo} dynamicCampusName={dynamicCampusName} />} />
          <Route path="/adminlogin" element={<AdminLoginComponent />} />

          <Route path="/register" element={<RegisterPage />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/changepasswordforadmin" element={<ChangePasswordForAdmin />} />


          {/* <Route path="/re-approval/:id" element={<ReApprovalComponent />} />
          <Route path="/rejectstatus" element={<RejectStatusComponent />} />
          <Route path="/withdraw" element={<WithdrawComponent />} /> */}

          {/* Protected Routes with Layout */}
          {/* <Route element={<Layout />}> */}
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout dynamicLogo={dynamicLogo} />}>
            <Route index element={<AdminRoute element={<Home dynamicLogo={dynamicLogo} dynamiBanner={dynamiBanner} />} />} />
            <Route path="mentor_requirement" element={<AdminRoute element={<MentorRequirementHome />} />} />
            <Route path="changepassword" element={<AdminRoute element={<ChangePassword />} />} />
            <Route path="settings" element={<AdminRoute element={<BrandingSettings />} />} />


            {/* <Route path="events" element={<EventHome />} /> */}
            <Route path='events' element={<EventHome />} />
            {/* <Route path="mentor_requirement" element={<AdminRoute element={<MentorRequirementHome />} />} /> */}
            <Route path="newsletter" element={<AdminRoute element={<NewsletterHome />} />} />
            <Route path="alumni_register_confirmation" element={<AdminRoute element={<RegistrationAlumniCofirmed />} />} />
            <Route path="reportsearch_course" element={<AdminRoute element={<AlumniReportSearchByCourse />} />} />
            <Route path="reportsearch_name" element={<AdminRoute element={<AlumniReportSearchByName />} />} />
            <Route path="profiledetails/:userId" element={<AdminRoute element={<ProfileDetails />} />} />
            <Route path="aboutus" element={<AboutUs />} />


            {/* <Route path="changepassword" element={<AdminRoute element={<ChangePassword />} />} />
            <Route path="events" element={<AdminRoute element={<EventHome />} />} /> */}
            {/* ...other admin routes */}
          </Route>

          {/* User Routes */}
          <Route path="/user" element={<UserRoute element={<UserLayout dynamicLogo={dynamicLogo} />} />}>
            <Route path="/user" element={<UserRoute element={<WebsiteSideNav />} />}>

              <Route index element={<HomePage />} />
              {/* WebsiteSideNav */}
              <Route path='connections' element={<ConnectionsHome />} />
              <Route path='suggestionconnections' element={<SuggestionConnections />} />
              <Route path='myconnections' element={<MyConnections />} />


              {/* <Route path='connectfriends' element={<AllUsers />} /> */}
            </Route>
            <Route path='aboutus' element={<AboutUs />} />
            <Route path='postjobs' element={<PostJobHome />} />
            <Route path='postinternship' element={<PostInernshipHome />} />
            <Route path='searchjob' element={<SearchJobVacancy />} />
            <Route path='searchinternship' element={<SearchInternshipVacancy />} />
            <Route path='uploadresume' element={<ResumeUpload />} />
            <Route path='messages' element={<MessageChatHome />} />
            <Route path='notification' element={<Notification />} />
            <Route path='editprofile' element={<EditProfilePage />} />
            <Route path='connectfriends' element={<AllUsers />} />
            <Route path="viewprofiledetails/:userId" element={<ProfileDetails />} />














          </Route>
          {/* </Route> */}

        </Routes>
            
      </AuthProvider>
      {/* <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      /> */}
    </ThemeProvider>

  );
}

export default App;

